import { ENDPOINTS } from '@constants/endpoints.constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { GenericAPI } from './generic-api.service';
import { Allergen } from '@core/models/allergen';
import { Observable, from, throwError } from 'rxjs';
import { ApplicationDatabaseService } from 'providers/db/application-database.service';
import { flatMap, share, finalize, catchError } from 'rxjs/operators';
import { LoadingService } from '@services/loading.service';

@Injectable({
  providedIn: 'root'
})

export class AllergensApiService extends GenericAPI {

  constructor(
    private http: HttpClient,
    public applicationDatabaseService: ApplicationDatabaseService,
    private loadingService: LoadingService
  ) {
    super(applicationDatabaseService);
  }

  public getAllergens(): Observable<Allergen[]> {
    this.loadingService.openLoading();
    return from(this.getGenericHeaders()).pipe(
      flatMap((defaultHeaders) => {
        return this.http.get<Allergen[]>(
          `${environment.rest.baseUrl}/${ENDPOINTS.ALLERGENS}`,
          {
            headers: defaultHeaders
          }
        ).pipe(
          share(),
          finalize(() => this.loadingService.closeLoading()),
          catchError(error => {
            return throwError(error);
        })
        );
      })
    );
  }

  public getAllergen(id: number): Observable<Allergen> {
    this.loadingService.openLoading();
    return from(this.getGenericHeaders()).pipe(
      flatMap((defaultHeaders) => {
        return this.http.get<Allergen>(
          `${environment.rest.baseUrl}/${ENDPOINTS.ALLERGENS}/${id}`,
          {
            headers: defaultHeaders
          }
        ).pipe(
          share(),
          finalize(() => this.loadingService.closeLoading()),
          catchError(error => {
            return throwError(error);
        })
        );
      })
    );
  }

}
